import React from 'react';
import {h, Component} from 'preact'

export default class WindowFooter extends Component {
    render() {
        const {
            poweredBy,
            powered_url,
            powered_name,
        } = this.props;

        return (
            <div className="window-footer">
                <div className="powered">
                    {poweredBy} <a target="_parent" href={powered_url}>{powered_name}</a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app/widget/WindowFooter.js